export default {
  created() {},
  methods: {
    /**
     * 운송수단 category 필터 (최적배차/오토바이/승용차/화물)
     * @param {number} code
     */
    filterVehicleCategory(vehicles, code) {
      if (code === null || vehicles === null) return;
      const category = vehicles.categories.find(
        (category) => category.code === code
      );

      return category ? category.displayName : "";
    },

    /**
     * 운송수단 category의 이미지 반환
     * @param {number} code
     */
    filterVehicleCategoryImage(vehicles, code) {
      if (code === null || vehicles === null) return;
      const category = vehicles.categories.find(
        (category) => category.code === code
      );
      return category.image ?? "";
    },

    /**
     * category에 따른 하위 type들의 필터
     * ex) 짐받이가 필요해요 / 짐받이 필요없어요
     * ex) 화물일경우 차종
     * @param {number} code
     */
    filterVehicleType(vehicles, code) {
      if (code === null || vehicles === null) return;
      const type = vehicles.types.find((type) => type.code === code);

      return type ? type.displayName : "";
    },

    /**
     * type에 따른 차량 특성 option의 필터
     * @param {number} code
     */
    filterVehicleOptions(vehicles, code) {
      if (code === null || vehicles === null) return;
      const option = vehicles.options.find((option) => option.code === code);

      return option ? option.displayName : "";
    },

    /**
     * 상하차 위치와 방법 필터
     * @param {number} code
     */
    filterPackage(vehicles, code) {
      if (code === null || vehicles === null) return;
      const option = vehicles.loadingUnloading.find(
        (option) => option.code === code
      );

      return option ? option.content : "";
    },
  },
};
